// @flow
import type { Element } from 'react';

import React from 'react';
import { Col, Row } from 'reactstrap';
import { getSiteClassRange } from '@hbrisk/sp3-risk-model-support/models/siteClasses/siteClasses.js';
import Tip from '#components/support/tooltips/Tip/index.jsx';

type Props = {|
  siteClass: string,
|};

const SiteClassRange = (props: Props): Element<typeof Row> => {
  const { siteClass } = props;
  const text =
    siteClass !== undefined ? (
      <div className="pt-2 pb-3">
        Vs30 Range: {getSiteClassRange(siteClass)} <Tip tipId="vs30" />
      </div>
    ) : null;
  return (
    <Row>
      <Col lg="4">{text}</Col>
    </Row>
  );
};

export default SiteClassRange;
